import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=4e527869&scoped=true&"
import script from "./vehicle.vue?vue&type=script&lang=js&"
export * from "./vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e527869",
  null
  
)

export default component.exports